import HeroLayout from 'components/Sections/Hero/HeroLayout';
import './styles.scss';
import { selectHomepageFirstScreen } from 'store/slices/HomepageSlice';
import { useSelector } from 'react-redux';
// @ts-ignore
import HeroComponent from './heroComponent';
import MainIllustration from 'components/AnimationIllustrations/MainIllustration';
import { getImageUrl } from 'helpers';
import useMediaQuery from 'hooks/useMediaQuery';

// const MainIllustration = lazy(() => import('components/AnimationIllustrations/MainIllustration'));


const Hero = ({ isLoading }) => {
    const { title, description, button_text
        , image
        , button_text_link
    } = useSelector(selectHomepageFirstScreen);
    const isMobile = useMediaQuery("max-width: 640px ")
    const imageUrl = getImageUrl(image);

    return (
        <HeroLayout image={isMobile ? <img src={imageUrl} alt="" /> : <MainIllustration isLoading={isLoading} />
        } isLoading={isLoading}>
            <HeroComponent title={title} desc={description} btnText={button_text} button_text_link={button_text_link} />
        </HeroLayout>
    );
};

export default Hero;
